export const useCompleteCollectionOptions = (embeddedComponent) => {
  embeddedComponent.setCollectionOptions({
    fields: 'eventually_due',
    futureRequirements: 'include',
  })
}
